"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkerWrapper = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
/**
 * Transparent wrapper that provides unified interface for legacy and Advanced Markers.
 * Existing code using marker.setIcon(), marker.setZIndex() works unchanged.
 *
 * @class MarkerWrapper
 */
class MarkerWrapper {
  /**
   * Creates a MarkerWrapper instance
   * @param {google.maps.Marker|google.maps.marker.AdvancedMarkerElement} nativeMarker - The underlying marker
   * @param {string} type - Either 'legacy' or 'advanced'
   */
  constructor(nativeMarker) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'legacy';
    this._marker = nativeMarker;
    this._type = type;
  }

  /**
   * Updates marker icon/appearance
   * For legacy: delegates to setIcon method
   * For advanced: updates HTML content
   */
  setIcon(iconConfig) {
    if (this._type === 'advanced') {
      this._updateAdvancedMarkerContent(iconConfig);
    } else {
      this._marker.setIcon(iconConfig);
    }
  }

  /**
   * Sets marker z-index for layering
   * For legacy: calls setZIndex method
   * For advanced: sets zIndex property
   */
  setZIndex(zIndex) {
    if (this._type === 'advanced') {
      this._marker.zIndex = zIndex;
    } else {
      this._marker.setZIndex(zIndex);
    }
  }

  /**
   * Sets marker animation (bounce, drop, etc)
   * For legacy: delegates to setAnimation
   * For advanced: no-op (not supported)
   */
  setAnimation(animation) {
    if (this._type === 'legacy') {
      this._marker.setAnimation(animation);
    }
    // Advanced markers don't support animation - no-op for backward compatibility
  }

  /**
   * Sets or removes the map for this marker
   * For legacy: calls setMap method
   * For advanced: sets map property
   */
  setMap(map) {
    if (this._type === 'advanced') {
      this._marker.map = map;
    } else {
      this._marker.setMap(map);
    }
  }

  /**
   * Adds event listener with automatic event name mapping for advanced markers
   * @param {string} eventName - Event name (click, mouseover, etc)
   * @param {Function} handler - Event handler function
   * @returns {Object} Listener handle with remove() method
   */
  addListener(eventName, handler) {
    if (this._type === 'legacy') {
      return {
        eventName,
        handler: this._marker.addListener(eventName, handler)
      };
    }

    // Map legacy event names to advanced marker events
    const eventMap = {
      click: 'click',
      spider_click: 'click',
      mouseover: 'mouseenter',
      mouseout: 'mouseleave'
    };
    const mappedEvent = eventMap[eventName] || eventName;
    this._marker.addEventListener(mappedEvent, handler);
    return {
      eventName,
      handler
    };
  }

  /**
   * Gets the marker position
   * @returns {google.maps.LatLng|google.maps.LatLngLiteral} Position
   */
  get position() {
    return this._marker.position;
  }

  /**
   * Gets the map instance the marker is attached to
   * @returns {google.maps.Map} Map instance
   */
  get map() {
    return (0, _map.default)(this._marker);
  }
  removeListeners(meta) {
    var _context;
    (0, _forEach.default)(_context = meta.eventListeners).call(_context, _ref => {
      let {
        handler,
        eventName
      } = _ref;
      if (this._type === 'advanced') {
        this._marker.removeEventListener(eventName, handler);
      } else {
        handler.remove();
      }
    });
  }

  /**
   * Returns the underlying native marker for direct access when needed
   * @returns {google.maps.Marker|google.maps.marker.AdvancedMarkerElement}
   */
  getUnderlyingMarker() {
    return this._marker;
  }

  /**
   * Updates the HTML content of an advanced marker based on icon config
   * @private
   */
  _updateAdvancedMarkerContent(iconConfig) {
    const content = this._marker.content;
    if (!(content instanceof HTMLElement)) return;

    // Handle URL-based custom icon
    if (iconConfig.url) {
      const img = content.querySelector('img');
      if (img) {
        img.src = iconConfig.url;
      } else {
        // Create new image element
        const newImg = document.createElement('img');
        newImg.src = iconConfig.url;
        content.innerHTML = '';
        content.appendChild(newImg);
      }
    }

    // Handle fill color (pin background)
    if (iconConfig.fillColor) {
      const pinElement = content.querySelector('.gmp-pin');
      if (pinElement) {
        pinElement.style.background = iconConfig.fillColor;
      }
    }

    // Handle opacity
    if (iconConfig.fillOpacity !== undefined) {
      content.style.opacity = iconConfig.fillOpacity;
    }

    // Handle stroke color (pin border)
    if (iconConfig.strokeColor) {
      const pinElement = content.querySelector('.gmp-pin');
      if (pinElement) {
        pinElement.style.borderColor = iconConfig.strokeColor;
      }
    }
  }
}
exports.MarkerWrapper = MarkerWrapper;